<template>
    <div class="flex w-full flex-col">
        <div
            class="p-md hide-scrollbar grid h-full w-full grid-cols-2 grid-rows-[auto_1fr] content-start gap-x-16 gap-y-12 overflow-y-auto pt-0"
        >
            <h1 class="col-span-2">Default groups</h1>
            <div class="gap-sm flex h-full flex-col">
                <div class="flex items-center gap-2">
                    <h2>Selected groups</h2>
                    <TagComponent :value="selected_list.length.toString()" variant="info" class-name="font-bold text-(--state-info-fg)" />
                </div>
                <draggable
                    :list="selected_list"
                    item-key="name"
                    v-bind="dragOptions"
                    class="gap-sm flex h-full flex-col"
                    @start="onDragStart"
                    @end="onDragEnd"
                >
                    <template #item="{ element, index }">
                        <GroupCard
                            :key="index"
                            :name="element.name"
                            :roles="element.organization_roles"
                            :sites="element.sites"
                            :regions="element.regions"
                            :request-types="element.request_types"
                        />
                    </template>
                </draggable>
            </div>

            <div class="gap-sm relative flex h-full flex-col">
                <div class="gap-sm flex h-full flex-col">
                    <div class="flex items-center gap-2">
                        <h2>Unselected groups</h2>
                        <TagComponent :value="unselected_list.length.toString()" variant="info" class-name="font-bold text-(--state-info-fg)" />
                    </div>
                    <draggable
                        :list="unselected_list"
                        item-key="name"
                        v-bind="dragOptions"
                        class="gap-sm relative flex h-full flex-col"
                        :class="{
                            'drag-boundry': !unselected_list.length,
                        }"
                        @start="onDragStart"
                        @end="onDragEnd"
                    >
                        <template #item="{ element, index }">
                            <GroupCard
                                :key="index"
                                :name="element.name"
                                :roles="element.organization_roles"
                                :sites="element.sites"
                                :regions="element.regions"
                                :request-types="element.request_types"
                            />
                        </template>
                    </draggable>

                    <div
                        v-if="!unselected_list.length"
                        class="top-3xl absolute flex w-full items-center justify-center"
                    >
                        <svg width="63" height="49" viewBox="0 0 63 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.93457 44.5309C9.35993 43.6726 8.947 42.6968 8.73937 41.6473L9.22986 41.5503C9.13625 41.0771 9.0871 40.5875 9.0871 40.086V38.1621H8.5871V34.3143H9.0871V30.4664H8.5871V26.6186H9.0871V22.7708H8.5871V18.9229H9.0871V16.999C9.0871 16.4975 9.13625 16.0079 9.22986 15.5348L8.73937 15.4377C8.947 14.3882 9.35993 13.4124 9.93457 12.5541L10.3501 12.8323C10.8978 12.0142 11.6022 11.3097 12.4203 10.762L12.1422 10.3465C13.0005 9.77186 13.9762 9.35893 15.0258 9.1513L15.1228 9.64179C15.596 9.54818 16.0856 9.49902 16.5871 9.49902H18.4828V8.99902H22.2741V9.49902H26.0654V8.99902H29.8567V9.49902H33.648V8.99902H37.4393V9.49902H41.2306V8.99902H45.0219V9.49902H48.8132V8.99902H52.6045V9.49902H54.5002C55.0017 9.49902 55.4912 9.54818 55.9644 9.64179L56.0615 9.1513C57.111 9.35893 58.0868 9.77186 58.9451 10.3465L58.6669 10.762C59.485 11.3097 60.1895 12.0142 60.7372 12.8323L61.1527 12.5541C61.7273 13.4124 62.1402 14.3882 62.3479 15.4377L61.8574 15.5348C61.951 16.0079 62.0002 16.4975 62.0002 16.999V18.9229H62.5002V22.7708H62.0002V26.6186H62.5002V30.4664H62.0002V34.3142H62.5002V38.1621H62.0002V40.086C62.0002 40.5875 61.951 41.0771 61.8574 41.5502L62.3479 41.6473C62.1402 42.6968 61.7273 43.6726 61.1527 44.5309L60.7372 44.2528C60.1895 45.0709 59.485 45.7753 58.6669 46.323L58.9451 46.7385C58.0867 47.3132 57.111 47.7261 56.0614 47.9337L55.9644 47.4432C55.4912 47.5368 55.0017 47.586 54.5002 47.586H52.6045V48.086H48.8132V47.586H45.0219V48.086H41.2306V47.586H37.4393V48.086H33.648V47.586H29.8567V48.086H26.0654V47.586H22.2741V48.086H18.4827V47.586H16.5871C16.0856 47.586 15.596 47.5368 15.1228 47.4432L15.0258 47.9337C13.9762 47.7261 13.0005 47.3132 12.1422 46.7385L12.4203 46.323C11.6022 45.7753 10.8978 45.0709 10.3501 44.2528L9.93457 44.5309Z"
                                :stroke="svgStyle ? 'var(--icon-primary)' : 'var(--icon-secondary)'"
                                stroke-dasharray="4 4"
                            />
                            <path
                                d="M0.999878 8.91309C0.999878 4.77096 4.35774 1.41309 8.49988 1.41309H46.4129C50.5551 1.41309 53.9129 4.77095 53.9129 8.91309V32C53.9129 36.1422 50.5551 39.5001 46.4129 39.5001H8.49987C4.35774 39.5001 0.999878 36.1422 0.999878 32.0001V8.91309Z"
                                :fill="svgStyle ? 'var(--icon-primary)' : 'var(--bg-lightest)'"
                            />
                            <path
                                d="M0.999878 8.91309C0.999878 4.77096 4.35774 1.41309 8.49988 1.41309H46.4129C50.5551 1.41309 53.9129 4.77095 53.9129 8.91309V32C53.9129 36.1422 50.5551 39.5001 46.4129 39.5001H8.49987C4.35774 39.5001 0.999878 36.1422 0.999878 32.0001V8.91309Z"
                                :stroke="svgStyle ? 'var(--icon-primary)' : 'var(--icon-secondary)'"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M22.16 13.827C22.5038 13.4832 22.9701 13.29 23.4564 13.29H28.123C28.2557 13.29 28.3828 13.3427 28.4766 13.4365L33.1433 18.1032C33.237 18.1969 33.2897 18.3241 33.2897 18.4567V25.79C33.2897 26.2763 33.0966 26.7426 32.7527 27.0864C32.4089 27.4302 31.9426 27.6234 31.4564 27.6234H23.4564C22.9701 27.6234 22.5038 27.4302 22.16 27.0864C21.8162 26.7426 21.623 26.2763 21.623 25.79V15.1234C21.623 14.6371 21.8162 14.1708 22.16 13.827ZM23.4564 14.29C23.2354 14.29 23.0234 14.3778 22.8671 14.5341C22.7108 14.6904 22.623 14.9024 22.623 15.1234V25.79C22.623 26.0111 22.7108 26.223 22.8671 26.3793C23.0234 26.5356 23.2354 26.6234 23.4564 26.6234H31.4564C31.6774 26.6234 31.8894 26.5356 32.0456 26.3793C32.2019 26.223 32.2897 26.0111 32.2897 25.79V18.9567H28.123C27.8469 18.9567 27.623 18.7328 27.623 18.4567L27.623 14.29H23.4564ZM28.623 14.9971L31.5826 17.9567H28.623L28.623 14.9971Z"
                                :fill="svgStyle ? 'var(--text-on-accent)' : 'var(--icon-secondary)'"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <BottomButtons
        arrow
        :handle-submit="submit"
        :disabled="disable"
        :sticky="false"
        dont-disable
        :loading="loading"
        @cancel="$emit('cancel')"
    />
</template>

<script setup lang="ts">
import draggable from 'vuedraggable';
import GroupCard from '@/components/admin/organization/creation-process/group-card.vue';
import TagComponent from '@/components/ui/tag/TagComponent.vue';
import { computed, onMounted, ref, watch, type PropType, type Ref } from 'vue';
import type { AdminOrganizationDefaultGroup } from '@/stores/store-interfaces';
import BottomButtons from '@/components/bottom-buttons.vue';
import { overlapping } from '@/stores/helpers';

const unselected_list: Ref<Array<AdminOrganizationDefaultGroup>> = ref([]);
const selected_list: Ref<Array<AdminOrganizationDefaultGroup>> = ref([]);

const props = defineProps({
    unselected: Array as PropType<AdminOrganizationDefaultGroup[]>,
    selected: Array as PropType<AdminOrganizationDefaultGroup[]>,
    disable: Boolean,
    loading: Boolean,
});

onMounted(() => {
    if (props?.selected?.length === 0) {
        selected_list.value = props.unselected ?? [];
    } else {
        selected_list.value = props.selected ?? [];
        unselected_list.value = props.unselected ?? [];
    }
});

const dragOptions = computed(() => ({
    animation: 200,
    group: 'roles',
    disabled: false,
    ghostClass: 'ghost',
}));

const drag = ref<boolean>(false);
const svgStyle = ref<boolean>(false);

function onDragStart() {
    drag.value = true;
}

function onDragEnd() {
    drag.value = false;
}

watch(drag, () => {
    if (drag.value) {
        document.addEventListener('dragover', getMousePos);
    } else {
        document.removeEventListener('dragover', getMousePos);
    }
});

const getMousePos = (e: MouseEvent) => {
    const dropElement = document.querySelector('.drag-boundry');
    const bounds = dropElement?.getBoundingClientRect();
    if (bounds && overlapping(bounds, e.clientX, e.clientY, 20)) {
        dropElement?.classList.add('drag-boundry__mouse');
        svgStyle.value = true;
    } else {
        dropElement?.classList.remove('drag-boundry__mouse');
        svgStyle.value = false;
    }
    return {
        x: e.clientX,
        y: e.clientY,
    };
};

const emit = defineEmits(['submit', 'cancel']);

const submit = () => {
    const selectedGroups = selected_list.value.map((group) => {
        return {
            default_group_id: group.default_group_id,
        };
    });

    emit('submit', selectedGroups);
};
</script>

<style scoped>
@reference '@/assets/styles/default.css';

.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: var(--surface-highlight);
}

.list-group {
    height: 100%;
}

.drag-boundry {
    border: 2px dashed var(--color-gray-300);
    border-radius: var(--size-sm);
    transition: border-color 0.3s ease-in-out;
    position: relative;
}

.drag-boundry::after {
    content: 'Drag and rop roles here';
    position: absolute;
    width: 100%;
    top: calc((var(--size-3xl)));
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
}

.drag-boundry__mouse {
    border-color: var(--color-blue-500);
}

.drag-boundry__mouse::after {
    color: var(--color-blue-500);
    fill: currentColor;
}

path {
    transition: 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
